import { CanDeactivateFn } from '@angular/router';
import { CanLeavePage } from '../interfaces/can-leave-page.interface';

export const canLeavePageGuard: CanDeactivateFn<CanLeavePage> = (component) => {
  return component.canLeave ? component.canLeave() : true;
};
